import React from "react";
import DropdownMentor from "./DropdownMentor";
import DatePicker from "./DatePicker";
import ItemWrapper from "./ItemWrapper";
import { useStyles } from "./style";
import moment from "moment-timezone";
import convert from "../../../assets/images/convert.svg";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";

const CreateClassRequest = ({
  classReqdata,
  setClassReqdata,
  warningMsg,
  courseList,
  setCourseList,
  studentList,
  setWarningMsg,
}) => {
  const classes = useStyles();

  const formatDate = (e) => {
    return new Date(
      moment(new Date(e)).format("YYYY-MM-DD hh:mm A")
    ).toISOString();
  };
  const convertDateAndTime = (date, timezoneBase, timezoneTo) => {
    // const baseTime = moment.tz(date, "YYYY-MM-DD HH:mm:ss", timezoneBase);
    // return moment(baseTime).tz(timezoneTo).format("YYYY-MM-DD hh:mm A");

    const naiveDateTime = moment(date).format("YYYY-MM-DD HH:mm:ss");
    const interpretedTime = moment.tz(
      naiveDateTime,
      "YYYY-MM-DD HH:mm:ss",
      timezoneBase
    );
    return interpretedTime.tz(timezoneTo).format("YYYY-MM-DD hh:mm A");
  };

  const validateDate = (e) => {
    const selectedDate = new Date(e);
    const now = new Date();

    // Add 2 hours and 5 minutes to current time
    const minValidTime = new Date(now.getTime() + (2 * 60 + 5) * 60 * 1000);

    if (selectedDate.getTime() < minValidTime.getTime()) {
      setWarningMsg("Please select a time at least 2 hours from now.");
      return false;
    }

    return true;
  };

  const handleMentorDateChange = (e) => {
    if (validateDate(e)) {
      if (classReqdata?.student?.timezone) {
        const convertedDate = convertDateAndTime(
          e,
          "Asia/Kolkata",
          classReqdata?.student?.timezone
        );
        setClassReqdata((prev) => {
          return {
            ...prev,
            studentTime: convertedDate,
            mentorTime: formatDate(e),
          };
        });
        setWarningMsg("");
      } else {
        setWarningMsg("Please select student first.");
      }
    }
  };
  const handleStudentDateChange = (e) => {
    if (classReqdata?.student?.timezone) {
      const convertedDate = convertDateAndTime(
        e,
        classReqdata?.student?.timezone,
        "Asia/Kolkata"
      );
      if (validateDate(convertedDate)) {
        setClassReqdata((prev) => {
          return {
            ...prev,
            studentTime: formatDate(e),
            mentorTime: convertedDate,
          };
        });
        setWarningMsg("");
      }
    } else {
      setWarningMsg("Please select student first.");
    }
  };
  const handleStudentSelection = (e, { value }) => {
    const selectedStudent = studentList?.find(
      (item) => item.studentId === value
    );

    if (selectedStudent?.courses && selectedStudent?.courses?.length > 0) {
      const courses = selectedStudent?.courses?.map((course) => {
        return {
          key: course.courseId,
          value: course.courseId,
          text: course.courseName,
          ...course,
        };
      });
      setCourseList(courses);
    }
    setClassReqdata((prev) => {
      return { ...prev, student: selectedStudent };
    });
    setWarningMsg("");
  };
  const handleCourseSelection = (e, { value }) => {
    const selectedCourse = courseList?.find((item) => item.courseId === value);
    setClassReqdata((prev) => {
      return { ...prev, courses: selectedCourse };
    });
    setWarningMsg("");
  };

  const formData = [
    {
      key: "student-select",
      type: "select",
      title: "Student",
      handleChange: handleStudentSelection,
      list: studentList,
      value: classReqdata.student.value,
      placeholder: "Select Student",
    },
    {
      key: "course-select",
      type: "select",
      title: "Course",
      handleChange: handleCourseSelection,
      list: courseList,
      value: classReqdata.courses.value,
      placeholder: "Select Course",
    },
    {
      key: "mentor-date",
      type: "datePicker",
      title: "Your Timezone (IST)",
      handleChange: handleMentorDateChange,
      value: classReqdata.mentorTime,
    },
    {
      key: "swap-icon",
      type: "icon",
    },
    {
      key: "student-date",
      type: "datePicker",
      title: `Student Timezone (${
        classReqdata?.student?.timezoneAbbr || "CST"
      })`,
      handleChange: handleStudentDateChange,
      value: classReqdata.studentTime,
    },
  ];

  return (
    <div className={classes.formContainer}>
      {formData?.map((item) => {
        if (item.type === "select") {
          return (
            <ItemWrapper key={item.key} title={item.title}>
              <DropdownMentor
                list={item.list}
                value={item.value}
                handleChange={item.handleChange}
                placeholder={item.placeholder}
              />
            </ItemWrapper>
          );
        } else if (item.type === "icon") {
          return (
            <div className={classes.swapIconContainer}>
              <img src={convert} alt="convert" className={classes.swapIcon} />
            </div>
          );
        } else {
          return (
            <ItemWrapper key={item.key} title={item.title}>
              <DatePicker
                handleDateChange={item.handleChange}
                value={item.value}
              />
            </ItemWrapper>
          );
        }
      })}
      {warningMsg && warningMsg.length && (
        <div className={classes.warningContainer}>
          <WarningRoundedIcon style={{ color: "#D33636", fontSize: 16, marginRight: 5 }} />
          <p className={classes.warningMsg}>{warningMsg}</p>
        </div>
      )}
    </div>
  );
};

export default CreateClassRequest;
